import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'
import { SCRAPING_SESSION_VALIDATION_STATUSES } from '../../../constants'

const style = {
  width: '100%',
}

const ScrapingSessionValidationStatusFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { validationStatus } = getQueryParams(search)

  const handleChange = useCallback(
    validationStatus =>
      history.push(
        createUrl(pathname, search, {
          validationStatus,
          page: undefined,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Validation status" labelCol={{ span: 24 }}>
      <Select
        style={style}
        allowClear
        value={validationStatus}
        onChange={handleChange}
      >
        {Object.entries(SCRAPING_SESSION_VALIDATION_STATUSES).map(
          ([value, { name }]) => (
            <Select.Option key={value} value={value}>
              {name}
            </Select.Option>
          ),
        )}
      </Select>
    </Form.Item>
  )
}

export default ScrapingSessionValidationStatusFilter
